import { GridOverlay } from '@mui/x-data-grid-premium';
import { Typography } from 'src/components/PulseUI';

const NoVolumeOverlay = () => {
  return (
    <GridOverlay>
      <div className="flex flex-col items-center justify-center h-full px-4">
        <Typography
          variant="body2"
          color="secondary"
          className="whitespace-pre-wrap text-center"
        >
          No filter sets, encounters, or code sets applied.
        </Typography>
      </div>
    </GridOverlay>
  );
};

export default NoVolumeOverlay;
